var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInspectIcon = function SvgInspectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.775 14.651-2.966-2.944a7.205 7.205 0 0 0-.811-9.869 7.19 7.19 0 0 0-9.89.271 7.204 7.204 0 0 0 4.498 12.27 7.2 7.2 0 0 0 5.092-1.56l2.942 2.944a.8.8 0 0 0 1.135 0 .8.8 0 0 0 0-1.112M7.212 12.82a5.59 5.59 0 0 1-5.17-3.458A5.605 5.605 0 0 1 6.12 1.725a5.59 5.59 0 0 1 5.745 2.381 5.604 5.604 0 0 1-.696 7.072 5.6 5.6 0 0 1-3.958 1.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.32 8.088 9.7 4.313a.887.887 0 0 1 1.353 0 1.16 1.16 0 0 1 0 1.51l-4.057 4.53a1 1 0 0 1-.31.232.87.87 0 0 1-.732 0 1 1 0 0 1-.31-.232l-2.03-2.265a1.16 1.16 0 0 1 0-1.51.887.887 0 0 1 1.352 0z"
  })));
};
export { SvgInspectIcon as ReactComponent };